// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-contact{height:100%;width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.contact-us-details .details-section{padding-bottom:1.5rem}.contact-us-details .contact-us-body p a{--text-opacity:1;color:#8a0ffe;color:rgba(138,15,254,var(--text-opacity));font-weight:600;transition-property:all;transition-duration:.2s}.contact-us-details .contact-us-body p a:hover{--text-opacity:1;color:#f83d94;color:rgba(248,61,148,var(--text-opacity))}", ""]);
// Exports
module.exports = exports;
